import React, { useState } from "react";
// import { authService } from "../../utils/auth";
import OtpBaseComponent from "./OtpBaseComponent";

export default function OtpSection(props) {
  
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [resetOtp, setResetOtp] = useState(false);


  return (
    <>
      <div className="ph-container">
        {props?.product === 'bonds' ?<p className="main-title">
        OTP Confirmation For Liquidation Request
        </p> :
        <p className="main-title">
        {props.showSecond ? "OTP Confirmation For Quote Request" : "OTP Confirmation For Liquidation Request"}
        </p>}
        <div className="subtext d-flex justify-content-center align-items-center">
          <p className="title-sub">
            We have sent a verification code to {props?.phone} and {props?.userEmail}
          </p>
        </div>
        <OtpBaseComponent
          otp={props.otp}
          updateOtp={props.updateOtp}
          isresetOtp={resetOtp}
          verifyLoader={verifyLoader}
          verifyOtp={props?.verifyOtp}
          resendOtp={props.resendOtp}
        />
      </div>
    </>
  );
}
